import Vue from 'vue';
import Router from 'vue-router';
import Profile from './views/Profile.vue';
import Tickets from './views/Tickets.vue';
import Balance from './views/Balance.vue';
import Payment from './views/Payment.vue';
import Erip from './views/Erip.vue';
import ThankYou from './views/Thankyou.vue';
import Promotions from './views/Promotions.vue';
import EarlyBooking from './views/EarlyBooking.vue';
import Videos from './views/Videos.vue';
import Cards from './views/Cards.vue';

Vue.use(Router);

export default new Router({
  // mode: 'history',
  scrollBehavior: () => ({ y: 0 }),

  base: process.env.BASE_URL,
  mode: process.env.VUE_ROUTER_MODE,

  routes: [
    {
      path: '/',
      redirect: '/tickets',
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      children: [{
        path: '',
        redirect: 'info',
      }, {
        path: 'info',
        component: () => import('./views/profile/info'),
      }, {
        path: 'addresses',
        component: () => import('./views/profile/addresses'),
      }, {
        path: 'passports',
        component: () => import('./views/profile/passports'),
      }],
    },
    {
      path: '/subscribes',
      name: 'subscribes',
      component: () => import('./views/Subscribes'),
      children: [{
        path: '',
        redirect: 'active',
      }, {
        path: 'active',
        component: () => import('./views/subscribes/active'),
      }, {
        path: 'available',
        component: () => import('./views/subscribes/available'),
      }, {
        name: 'payment-by-subs',
        path: 'payment',
        component: () => import('./views/subscribes/payment'),
        props: true,
      }],
    },
    {
      path: '/tickets',
      name: 'tickets',
      component: Tickets,
      children: [{
        path: '',
        redirect: 'actual',
      },
      {
        path: 'all',
        component: () => import('./views/tickets/all'),
      }, {
        path: 'actual',
        component: () => import('./views/tickets/actual'),
      }, {
        path: 'booked',
        component: () => import('./views/tickets/booked'),
      }, {
        path: 'used',
        component: () => import('./views/tickets/used'),
      }],
    },
    {
      path: '/balance',
      name: 'balance',
      component: Balance,
    },
    {
      path: '/payment/:id',
      name: 'payment',
      component: Payment,
      props: true,
    },
    {
      path: '/thank-you',
      name: 'thankyou',
      component: ThankYou,
      props: true,
    },
    {
      path: '/erip/:orderId',
      name: 'erip',
      component: Erip,
      props: true,
    },
    {
      path: '/promotions',
      name: 'promotions',
      component: Promotions,
    },
    {
      path: '/videos',
      name: 'videos',
      component: Videos,
    },
    {
      path: '/early-booking',
      name: 'early-booking',
      component: EarlyBooking,
    },
    {
      path: '/cards',
      name: 'cards',
      component: Cards,
    },
  ],
});
